<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
          @submit.native.prevent
        >
          <el-form-item label="关键字">
            <el-input
              size="small"
              v-model="filter.query"
              @keyup.enter.native="requestSearch"
              placeholder="搜索件号或 Sap Code"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestSearch"
            >筛选</el-button
          >
          <el-button size="small" @click="requestSearch('reset')"
            >重置</el-button
          >
        </div>
      </div>
    </div>

    <div class="panel mt-20">
      <div class="flex mb-20 mobile-hide">
        <file-button
          obj="commodity_price"
          :filter="filter"
          v-permission="Auth.commodityPriceManage"
          @importCallback="handleImportCallBack"
        ></file-button>
        <el-button
          type="primary"
          size="small"
          class="ml-10"
          plain
          @click="recordDialog = true"
          >导入记录</el-button
        >
      </div>
      <el-table :data="list" stripe style="width: 100%">
        <el-table-column label="商品件号" prop="part_number"></el-table-column>
        <el-table-column label="客户" min-width="200px">
          <template slot-scope="scope">
            {{ scope.row.customer.name }}（{{ scope.row.sap_code }}）
          </template>
        </el-table-column>
        <el-table-column align="center" label="价格">
          <template slot-scope="scope">
            {{ scope.row.price.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="更新时间">
          <template slot-scope="scope">
            {{ $time(scope.row.updated_at).format('YYYY-MM-DD HH:mm') }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-popconfirm
              title="确认删除吗？"
              v-permission="Auth.commodityPriceManage"
              @confirm="handleDelete(scope.$index, scope.row.id)"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <ImportRecord :show.sync="recordDialog"></ImportRecord>
  </div>
</template>

<script>
import { commodityPriceList, deleteCommodityPrice } from '@/service/getData'
import ImportRecord from './price_record.vue'
export default {
  components: {
    ImportRecord,
  },
  data() {
    return {
      recordDialog: false,
      list: [],
      total: 0,
      filter: {
        size: 20,
        page: 1,
        query: '',
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.getData()
    },
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let params = this.clone(this.filter)
      params.page -= 1

      let res = await commodityPriceList(params)
      this.list = res.data.list
      this.total = res.data.total
    },
    requestSearch(reset = '') {
      this.filter.page = 1
      if (reset == 'reset') {
        this.filter.query = ''
      }
      this.getData()
    },
    async handleDelete(index, id) {
      let res = await deleteCommodityPrice(id)
      if (res.code == 0) {
        this.$message.success('删除成功')
        this.list.splice(index, 1)
      }
    },
    handleImportCallBack(res) {
      this.$message.success(`成功导入${res.data}条数据`)
      this.requestSearch('reset')
    },
  },
}
</script>